<template>
	<div class="col-12">
		<div class="form-group">
			<Editor
				v-model="form.instruction"
				class="instructions-editor"
			/>
		</div>
	</div>
</template>

<script>
	import { mapActions } from 'vuex'
	import { useConfirmation, useError } from '@/composables'
	import Editor from '@/components/shared/Editor'
	export default {
		name: 'Instructions',
		components: {
			Editor,
		},
		props: {
			config_id: {
				type: [Number, null],
			},
		},
		data() {
			return {
				instructions: null,
				form: {
					instruction: null,
				},
			}
		},
		methods: {
			...mapActions('system', ['StartLoading', 'FinishLoading']),
			GetOrganizationInstructions() {
				if (!this.config_id) return

				this.StartLoading()

				return window.api
					.call('post', '/get-organization-instructions', {
						config_id: this.config_id,
					})
					.then(({ data }) => {
						if (!data.response) {
							return
						}

						;(this.instructions = data.instructions),
							(this.form.instruction = data.instructions)
					})
					.finally(() => {
						this.FinishLoading()
					})
			},
			New() {
				window.jQuery('#modal-instructions').modal('show')
			},
			Save() {
				this.StartLoading()

				let obj = {
					config_id: this.config_id,
					instructions: this.form.instruction,
				}

				return window.api
					.call('post', '/save-organization-instructions', obj)
					.then(({ data }) => {
						if (!data.response) {
							useError(
								'Houve um erro ao salvar, contate o suporte.'
							)
							return
						}

						useConfirmation()

						this.GetOrganizationInstructions()
					})
					.finally(() => {
						this.FinishLoading()
						this.Close()
					})
			},
			Close() {
				this.form.instruction = null

				window.jQuery('#modal-instructions').modal('hide')
			},
		},
		beforeMount() {
			this.GetOrganizationInstructions()
		},
	}
</script>

<style lang="css" scoped>
	.instructions-editor :deep(.ql-editor) {
		height: 30vh !important;
	}
</style>
